import { ApolloError, useQuery } from '@apollo/client';
import ROOM_TYPE_QUERY from '@graphql/Room/queries/get-room-types.graphql';
import { IRoomType } from '@models/Room/i-room-type';

export default function useRoomTypes(includeHidden?: boolean): {
  loading: boolean;
  error?: ApolloError;
  roomTypes: IRoomType[];
  } {
  const { loading, error, data } = useQuery(ROOM_TYPE_QUERY, { variables: { includeHidden } });
  const roomTypes = data && Array.isArray(data.roomTypes) ? data.roomTypes : [];
  const badRoomTypeOldCodes = ['IDK', 'new'];
  return {
    loading,
    error,
    // Assumes the room types are returned in the preferred sort order (i.e. displayOrder field)
    roomTypes: roomTypes
      .filter(({ isHidden }: { isHidden: boolean }) => !isHidden)
      .filter(
        ({ oldCode }:{ oldCode?: string }) => !oldCode || !badRoomTypeOldCodes.includes(oldCode)
      ),
  };
}
